import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewAddressFormComponent } from './preview-address-form.component';
import { SharedModule } from 'app/shared/shared.module';
import { ContactInfoFormModule } from '../contact-info/contact-info.module';
import { MapPickerModule } from '../map-picker/map-picker.module';



@NgModule({
  declarations: [
    PreviewAddressFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ContactInfoFormModule,
    MapPickerModule
  ],
  exports: [
    PreviewAddressFormComponent
  ]
})
export class PreviewAddressFormModule { }
